import { ButtonState } from '@/atoms/NitButton/types'
import { uid } from '@/firebase'
import { getIdToken } from '@/helpers/apiClient'
import { StripeCheckoutSession } from '@/helpers/fs/stripe/checkoutSession'
import {
  NotificationType,
  useNotificationStore
} from '@/store/notificationStore'
import {
  FSStripeTeamSubscription,
  FSTeamPlan
} from '@WombatTechnology/nitte-time-lib'
import {
  DocumentData,
  DocumentReference,
  Timestamp,
  addDoc,
  onSnapshot
} from 'firebase/firestore'
export const SUCCESS_MESSAGE = 'アップグレードが完了しました'

export const useProPlanCheckout = () => {
  const { origin, pathname } = window.location
  return useCheckout({
    billing_address_collection: 'auto',
    line_items: [
      {
        price: import.meta.env.VITE_APP_STRIPE_PRO_PLAN_PRICE_ID,
        quantity: 1,
        tax_rates: [import.meta.env.VITE_APP_STRIPE_TAX_RATE_ID]
      }
    ],
    success_url: `${origin}${pathname}?message=${encodeURI(SUCCESS_MESSAGE)}&skipValidation=1`,
    cancel_url: `${origin}${pathname}?message=${encodeURI(
      'キャンセルしました'
    )}`
  })
}

export const useTeamPlanCheckout = (
  teamId: string,
  quantity: number,
  volumeDiscountPrice: FSTeamPlan<
    Timestamp,
    DocumentReference<FSStripeTeamSubscription<Timestamp>>
  >['volumeDiscountPrice']
) => {
  const { origin, pathname } = window.location

  const price = detectPriceID(volumeDiscountPrice, teamId)
  return useCheckout({
    metadata: {
      teamId
    },
    billing_address_collection: 'auto',
    line_items: [
      {
        price,
        quantity,
        tax_rates: [import.meta.env.VITE_APP_STRIPE_TAX_RATE_ID]
      }
    ],
    success_url: `${origin}${pathname}?message=${encodeURI(SUCCESS_MESSAGE)}&skipValidation=1`,
    cancel_url: `${origin}${pathname}?message=${encodeURI(
      'キャンセルしました'
    )}`
  })
}

const detectPriceID = (
  volumeDiscountPrice: FSTeamPlan<
    Timestamp,
    DocumentReference<FSStripeTeamSubscription<Timestamp>>
  >['volumeDiscountPrice'],
  teamId: string
) => {
  if (volumeDiscountPrice === 550) {
    return import.meta.env.VITE_APP_STRIPE_TEAM_PLAN_VOLUME_500_PRICE_ID
  }

  return import.meta.env.VITE_APP_STRIPE_TEAM_PLAN_PRICE_ID
}

const useCheckout = (docData: DocumentData) => {
  const buttonState = ref<ButtonState>('available')
  const notificationStore = useNotificationStore()

  const checkout = async () => {
    buttonState.value = 'loading'
    const doc = await addDoc(StripeCheckoutSession.collection(uid()!), docData)

    onSnapshot(doc, async (ds) => {
      const { error, url } = ds.data() as any
      if (error) {
        console.log('error', error)
        notificationStore.showNotification(
          'エラーが発生しました。解決しない場合はサポートまでお問い合わせください。',
          NotificationType.Error
        )
      }
      if (url) {
        // 成功した場合はURLにリダイレクト
        window.location.assign(url)
      }
    })
  }
  return {
    buttonState,
    checkout
  }
}

export const usePortalLink = () => {
  const buttonState = ref<ButtonState>('available')

  const gotoPortalLink = async (path: string) => {
    buttonState.value = 'loading'
    const idToken = await getIdToken()
    const url = `${import.meta.env.VITE_APP_CLOUD_FUNCTION_URL}/internal_api${path}`
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${idToken}`
      },
      body: JSON.stringify({ return_url: window.location.href })
    })
    if (!response.ok) {
      throw new Error(`Failed to create portal link: ${response.status}`)
    }
    const data = (await response.json()) as { url: string }
    window.location.assign(data.url)
  }

  const gotoPersonalPortalLink = () => gotoPortalLink('/users/me/portal_link')

  const gotoTeamPortalLink = (team_id: string) =>
    gotoPortalLink(`/teams/${team_id}/portal_link`)

  return {
    buttonState,
    gotoPersonalPortalLink,
    gotoTeamPortalLink
  }
}
